import React from 'react';

const projects = [
  {
    title: "Banking AI Assistant",
    description: "Intent extraction microservice using llama-3.1 running locally on Pi 4. Classifies user banking requests and returns structured JSON components to the frontend.",
    tags: ["FastAPI", "Ollama", "Python", "Docker"],
    link: "#banking",
  },
  {
    title: "Retail AI Assistant",
    description: "Intent extraction microservice using llama-3.1 running locally on Pi 4. Classifies user banking requests and returns structured JSON components to the frontend.",
    tags: ["FastAPI", "Ollama", "Python", "Docker"],
    link: "#retail",
  },
  {
    title: "Microservices Stack",
    description: "Production microservices architecture with Spring Boot, FastAPI, and .NET communicating over Docker internal networking.",
    tags: ["Spring Boot", ".NET", "FastAPI", "Docker Compose"],
    link: null,
  },
  {
    title: "Infrastructure on Pi 4",
    description: "Full self-hosted stack: Nginx Proxy Manager, Jenkins CI/CD, Portainer, and all services running on a Raspberry Pi 4 with 4GB RAM.",
    tags: ["Raspberry Pi", "Nginx", "Jenkins", "Portainer"],
    link: null,
  },
  
];

export default function Projects() {
  return (
    <section id="projects" className="py-24 px-6 max-w-5xl mx-auto">
      <p className="text-accent font-body text-sm tracking-[0.2em] uppercase mb-4">Projects</p>
      <h2 className="font-display text-4xl text-ink mb-16">What I've built</h2>

      <div className="grid md:grid-cols-3 gap-6">
        {projects.map(({ title, description, tags, link }) => (
          <div
            key={title}
            className="border border-ink/10 p-8 hover:border-accent/50 transition-all duration-300 group"
          >
            <h3 className="font-display text-xl text-ink mb-3 group-hover:text-accent transition-colors duration-200">
              {title}
            </h3>
            <p className="font-body text-sm text-muted leading-relaxed mb-6">
              {description}
            </p>
            <div className="flex flex-wrap gap-2 mb-6">
              {tags.map(tag => (
                <span
                  key={tag}
                  className="text-xs font-body px-2 py-1 border border-accent/30 text-accent"
                >
                  {tag}
                </span>
              ))}
            </div>
              {link && (
              <a
                href={link}
                //target="_blank"
                //rel="noopener noreferrer"
                className="text-xs font-body text-muted hover:text-accent transition-colors tracking-wide uppercase"
              >
                View Live →
              </a>
              
            )}
            
          </div>
        ))}
      </div>
    </section>
  );
}
